import { Component, EventEmitter, Inject, Input, Output, OnInit } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwAnnouncement
 * @module mw.components.announcement
 *
 * @description
 * The announcement component is a component that attaches to our application's header
 * and display a message to your end user. The announcement component expects content that can be
 * HTML or plaintext and a optional onClose event that handles anything you need done after the
 * announcement is closed. The component also supports transclusion of
 * action icons/buttons via the <code>mw-announcement-actions</code> translclusion slot.  If actions are provided,
 * the default 'close' icon button will not be displayed.
 *
 * @param {function} [on-close] - A function you want to have called when the announcement is closed out
 * @param {boolean} [is-close-visible] - Boolean to decide whether or not the announcement close action will be visible
 *
 * @usage
 * <hljs hljs-language="html">
 *  <mw-announcement on-close="$ctrl.onClose($event)">
 *      Here is a wonderful announcement!
 * </mw-announcement>
 * </hljs>
 */
@Component({
    selector: 'mw-announcement',
    template: `
        <div class="mw-announcement">
            <ng-transclude class="mw-announcement__content-container"> </ng-transclude>
            <ng-transclude ng-transclude-slot="mwAnnouncementActions">
                <div class="mw-announcement__close" ng-if="$ctrl.isCloseVisible">
                    <mw-icon-button svg-icon="navigation:ic_close_24px" aria-label="Close" ng-click="$ctrl.closeAnnouncement()" hover="true"></mw-icon-button>
                </div>
            </ng-transclude>
        </div>
    `,
    legacy: {
        transclude: {
            mwAnnouncementActions: '?mwAnnouncementActions'
        }
    }
})
export class AnnouncementComponent implements OnInit {
    @Input('<') isCloseVisible: boolean;
    @Output() onClose = new EventEmitter();

    constructor(@Inject('mwAnnouncementService') private mwAnnouncementService) {}

    ngOnInit() {
        this.isCloseVisible = this.isCloseVisible === false ? false : true;
    }

    closeAnnouncement(event) {
        this.onClose.emit({event});
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/announcement/announcement.component.ts